export default __webpack_public_path__ + "cd6f46e51eab41b59f8e0698e3500cc2.png";